<template>
  <ActionPopover
    class="keyword-planner-add-keyword-error"
    :show="show"
    @hide="$emit('hide')"
  >
    <div class="keyword-planner-add-keyword-error__alert">
      <ElAlert type="success" show-icon :closable="false">
        {{ $t('ADVERTISEMENT.KEYWORDPLANNER.ADD_NEGATIVE_KEYWORD_ALERT') }}
      </ElAlert>
    </div>
    <div class="keyword-planner-add-keyword-error__info">
      <h2 class="keyword-planner-add-keyword-error__info-title">
        {{
          $t('ADVERTISEMENT.KEYWORDPLANNER.ADD_NEGATIVE_KEYWORD_ERROR_TITLE')
        }}
      </h2>
      <p class="keyword-planner-add-keyword-error__info-description">
        {{
          $t(
            'ADVERTISEMENT.KEYWORDPLANNER.ADD_NEGATIVE_KEYWORD_ERROR_DESCRIPTION',
          )
        }}
      </p>
    </div>
    <div class="keyword-planner-add-keyword-error__keywords">
      <h2 class="keyword-planner-add-keyword-error__keywords-title">
        {{
          $t(
            'ADVERTISEMENT.KEYWORDPLANNER.ADD_NEGATIVE_KEYWORD_ERROR_KEYWODS_TITLE',
          )
        }}
      </h2>
      <div class="keyword-planner-add-keyword-error__keywords-list">
        <ElTag
          v-for="keyword in keywords"
          :key="keyword"
          class="keyword-planner-add-keyword-error__keywords-list-item"
          type="danger"
        >
          {{ keyword }}
        </ElTag>
      </div>
    </div>
  </ActionPopover>
</template>

<script>
import ActionPopover from '../../../../../common/ActionPopover';

export default {
  name: 'KeywordPlannerAddKeywordError',
  components: {
    ActionPopover,
  },
  props: {
    errors: {
      type: Array,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    keywords() {
      return this.errors.map(({ object: { keyword } }) => keyword);
    },
  },
};
</script>

<style lang="scss">
.keyword-planner-add-keyword-error {
  width: rem-calc(320px);
  color: #000;

  padding: $global-padding 0;

  &__alert,
  &__info,
  &__keywords {
    padding: 0 $global-padding;
  }

  &__alert {
    padding-bottom: $global-padding;
    margin-bottom: $global-margin;

    border-bottom: 1px dashed #dfdfdf;
  }

  &__info-title,
  &__keywords-title {
    font-size: rem-calc(13px);
    font-weight: bold;
  }

  &__info-description {
    font-size: rem-calc(13px);
  }

  &__keywords-list-item {
    &:not(:last-child) {
      margin-right: calc($global-margin / 2);
    }
    @include rtl() {
      margin-right: 0;

      &:not(:last-child) {
        margin-left: calc($global-margin / 2);
      }
    }
  }
}
</style>
